const routes = [
    {
        path: '/roles',
        component: () => import('@/pages/rolesAndPermissions/List.vue'),
        meta: { breadCrumb: 'Roles and Permissions', entity: 'editUsers' },
        name: 'rolesAndPermissions',
    },
]

export default routes
